import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="footer__top">
        <div>
          <div className="footer__brand">
            Soundwisdom <em>AI</em>
            <small>慧声计算机科技 · SHENZHEN</small>
          </div>
        </div>

        <div className="footer__col">
          <h4>产品</h4>
          <a
            href="https://aivideo.soundwisdomai.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            慧声有漫
          </a>
          <a
            href="https://tapflick.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tapflick
          </a>
          <p>AI 创作工具 · 即将到来</p>
        </div>

        <div className="footer__col">
          <h4>合作</h4>
          <a href="mailto:zhangyuntian@soundwisdomai.com">
            zhangyuntian@soundwisdomai.com
          </a>
          <p>漫剧合作 / IP 共创 / 渠道联运</p>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {year} 慧声计算机科技 · ALL RIGHTS RESERVED</span>
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
        >
          粤 ICP 备 2024338424 号
        </a>
      </div>
    </footer>
  );
}

export default Footer;
